/* eslint jsx-a11y/anchor-is-valid: off */
import React, { useState, useEffect, useRef } from 'react';
import styled from 'styled-components';
import { connect, useDispatch } from 'react-redux';
import { Colors } from '../common/colors';
import IMAGES from '../common/images';
import { get, range } from 'lodash';
import PigeitCaptcha from './PigeitCaptcha.component';
import { api_businessReviews_add, modalQueue, setupAnimatedLoader } from '../redux/actions';
import { showErrorMessage, isDescendant, attachEvent, detachEvent } from '../common/functions';
import CONSTANTS from '../common/constants';
import PigeItInput from './PigeItInput.component';

const defaultImg = 'iVBORw0KGgoAAAANSUhEUgAAAfQAAAH0CAYAAADL1t+KAAAGJ0lEQVR42u3VQREAAAQAMPon81GJCr7uthLL6p4AAF5LoQOA0AEAoQMAQgcAhA4AQgcAhA4ACB0AEDoACB0AEDoAIHQAQOgAIHQAQOgAgNABAKEDgNABAKEDAEIHAIQOAEIHAIQOAAgdABA6AAgdABA6ACB0AEDoACB0AEDoAIDQAQChA4DQAQChAwBCBwCEDgBCBwCEDgAIHQAQOgAIXegAIHQAQOgAgNABAKEDgNABAKEDAEIHAIQOAEIHAIQOAAgdABA6AAgdABA6ACB0AEDoACB0AEDoAIDQAQChA4DQAQChAwBCBwCEDgBCBwCEDgAIHQAQOgAIHQAQOgAgdABA6AAgdABA6ACA0AEAoQOA0AEAoQMAQgcAhA4AQgcAhA4ACB0AEDoACF3oACB0AEDoAIDQAQChA4DQAQChAwBCBwCEDgBCBwCEDgAIHQAQOgAIHQAQOgAgdABA6AAgdABA6ACA0AEAoQOA0AEAoQMAQgcAhA4AQgcAhA4ACB0AEDoACB0AEDoAIHQAQOgAIHQAQOgAgNABAKEDgNABAKEDAEIHAIQOAEIXOgAIHQAQOgAgdABA6AAgdABA6ACA0AEAoQOA0AEAoQMAQgcAhA4AQgcAhA4ACB0AEDoACB0AEDoAIHQAQOgAIHQAQOgAgNABAKEDgNABAKEDAEIHAIQOAEIHAIQOAAgdABA6AAgdABA6ACB0AEDoACB0AEDoAIDQAQChA4DQAQChAwBCBwCEDgBCFzoACB0AEDoAIHQAQOgAIHQAQOgAgNABAKEDgNABAKEDAEIHAIQOAEIHAIQOAAgdABA6AAgdABA6ACB0AEDoACB0AEDoAIDQAQChA4DQAQChAwBCBwCEDgBCBwCEDgAIHQAQOgAIHQAQOgAgdABA6AAgdABA6ACA0AEAoQOA0IUOAEIHAIQOAAgdABA6AAgdABA6ACB0AEDoACB0AEDoAIDQAQChA4DQAQChAwBCBwCEDgBCBwCEDgAIHQAQOgAIHQAQOgAgdABA6AAgdABA6ACA0AEAoQOA0AEAoQMAQgcAhA4AQgcAhA4ACB0AEDoACB0AEDoAIHQAQOgAIHQAQOgAgNABAKEDgNCFDgBCBwCEDgAIHQAQOgAIHQAQOgAgdABA6AAgdABA6ACA0AEAoQOA0AEAoQMAQgcAhA4AQgcAhA4ACB0AEDoACB0AEDoAIHQAQOgAIHQAQOgAgNABAKEDgNABAKEDAEIHAIQOAEIHAIQOAAgdABA6AAgdABA6ACB0AEDoACB0oQOA0AEAoQMAQgcAhA4AQgcAhA4ACB0AEDoACB0AEDoAIHQAQOgAIHQAQOgAgNABAKEDgNABAKEDAEIHAIQOAEIHAIQOAAgdABA6AAgdABA6ACB0AEDoACB0AEDoAIDQAQChA4DQAQChAwBCBwCEDgBCBwCEDgAIHQAQOgAIHQAQOgAgdABA6AAgdKEDgNABAKEDAEIHAIQOAEIHAIQOAAgdABA6AAgdABA6ACB0AEDoACB0AEDoAIDQAQChA4DQAQChAwBCBwCEDgBCBwCEDgAIHQAQOgAIHQAQOgAgdABA6AAgdABA6ACA0AEAoQOA0AEAoQMAQgcAhA4AQgcAhA4ACB0AEDoACF3oACB0AEDoAIDQAQChA4DQAQChAwBCBwCEDgBCBwCEDgAIHQAQOgAIHQAQOgAgdABA6AAgdABA6ACA0AEAoQOA0AEAoQMAQgcAhA4AQgcAhA4ACB0AEDoACB0AEDoAIHQAQOgAIHQAQOgAgNABAKEDgNABAKEDAEIHAIQOAEIHAIQOAAgdABA6AAhd6AAgdABA6ACA0AEAoQOA0AEAoQMAQgcAhA4AQgcAhA4ACB0AEDoACB0AEDoAIHQAQOgAIHQAQOgAgNABAKEDgNABAKEDAEIHAIQOAEIHAIQOAAgdABA6AAgdABA6ACB0AEDoACB0AEDoAIDQAQChA4DQAQChAwBCBwCEDgBCFzoACB0AEDoAIHQAQOgAIHQAQOgAgNABAKEDgNABAKEDAEIHAIQOAEIHAIQOAAgdABA6AAgdABA6ACB0AEDoACB0AEDoAIDQAQChA4DQAQChAwBCBwBuFpG9oZ+djA0nAAAAAElFTkSuQmCC';
function MainPageBusinessReviewsComponent(props) {

  const dispatch = useDispatch();
  const reviews = get(props, 'businessReviews.length', 0) !== 0 ? props.businessReviews : [];
  const [formOpen, setFormOpen] = useState(false);
  const [fields, setFields] = useState({
    'business-full-name': { value: '', error: false },
    'business-name': { value: '', error: false },
    'business-email': { value: '', error: false },
    'business-address': { value: '', error: false },
    'business-industry': { value: '', error: false },
    'business-link': { value: '', error: false },
    'business-about': { value: '', error: false },
    'business-offer': { value: '', error: false },
  });
  const [reviewsToShow, setReviewsToShow] = useState(3);
  const sectionsRef = useRef(0);
  const sections = parseInt(reviews.length / reviewsToShow);
  sectionsRef.current = sections;
  const [section, setSection] = useState(0);
  const sectionRef = useRef(0);
  const [captcha, setCaptcha] = useState('');
  const lastPressedRef = useRef(Date.now());
  const [reviewToOpen, setReviewToOpen] = useState(-1);
  const reviewToOpenRef = useRef(-1);
  const openReviewRef = useRef();
  useEffect(() => {
    sectionRef.current = section;
  }, [section]);
  useEffect(() => {
    reviewToOpenRef.current = reviewToOpen;
  }, [reviewToOpen]);

  useEffect(() => {
    attachEvent(window, 'click', setToCloseOnClickOutside);
    return function () {
      detachEvent(window, 'click', setToCloseOnClickOutside);
    }
  }, []);

  useEffect(() => {
    if (props.displayMode === 'DESKTOP') {
      setReviewsToShow(3);
      setSection(0);
    } else {
      setReviewsToShow(1);
      setSection(0);
    }
  }, [props.displayMode]);

  useEffect(() => {
    let interval = setInterval(() => {
      if ((Date.now() - lastPressedRef.current) > 9000) {
        //     onRightClick();
      }
    }, 10000);
    return () => {
      clearInterval(interval);
    };
  }, []);

  if (reviews.length >= reviewsToShow) {
    return (
      <MainPageBusinessReviewsStyle>
        <div className='main-header'>Here's what our customers have to say…</div>
        <div className='second-header'>The best part about shipping a package is imagining how exciting it is to receive it! At ShipWinner, we know that shipping is all about people. That's why we love hearing from our customers. Read what our clients have to say about us, and don't forget to leave a review yourself!</div>
        <div ref={openReviewRef} className='display-flex reviews-container'>
          <button className={'left-button '+(sections<=1?'hide':'')} onClick={onLeftClick}><IMAGES.arrowLeft /></button>
          {range(section * reviewsToShow, section * reviewsToShow + reviewsToShow).map(i => {
            const format = get(reviews, '[' + i + '].imageFormat', 'png');
            const image = get(reviews, '[' + i + '].profilePhoto', defaultImg);
            const text = reviews[i].textAboutPigeit + (reviews[i].textAboutOffer ? (". " + reviews[i].textAboutOffer) : '');
            let shortText = text;
            if (shortText.length > 100) {
              shortText = text.substr(0, 300).substr(0, text.substr(0, 100).lastIndexOf(' '));
            }
            return (
              <button key={i} onClick={() => setReviewToOpen(i)} className={'review-container '}>
                {i === reviewToOpen && <div className={'floating-container'}>
                  <img className='profile-image' src={'data:image/' + format + ';base64,' + image} />
                  <div className='review-title'>{reviews[i].businessName + (reviews[i].fullName ? (", " + reviews[i].fullName) : '')}</div>
                  <div className='review-text'>{text}</div>
                  {reviews[i].linkToSite && <a className='link-to-website' target='_blank' href={reviews[i].linkToSite}>Go to Website</a>}
                </div>}
                <img className='profile-image' src={'data:image/' + format + ';base64,' + image} />
                <div className='review-title'>{reviews[i].businessName + (reviews[i].fullName ? (", " + reviews[i].fullName) : '')}</div>
                <div className='review-text'>{shortText}<span className='show-more'>&nbsp;&nbsp;[+]</span></div>
              </button>
            );
          })}
          <button className={'right-button '+(sections<=1?'hide':'')} onClick={onRightClick}><IMAGES.arrowRight /></button>
        </div>
        <div className={'navigtion-container display-flex desktop-component '+(sections<=1?'hide':'')}>
          {range(0, sections).map(i => {
            return (
              <button className={'circle' + (i === section ? ' selected' : '')} key={i} onClick={() => { setSection(i); lastPressedRef.current = Date.now(); }} />
            );
          })}
        </div>
        <div className='main-header'>We'd like to give back to you!</div>
        <div className='second-header'>Thanks for shipping with ShipWinner! Now we'd like to return the favor. Write a review for our website, and we'll provide a link to your brand to help direct traffic back to you. You can further promote your business by offering a discount if you'd like. We love sharing other great brands with our customers!</div>
        {formOpen &&
          <form className='form'>
            <div className='email-address-header'>*Your email and company's address will not be published. </div>
            <div className='two-fields display-flex'>
              <div className='input-with-label'>
                <PigeItInput label='Full Name' id='business-full-name' value={fields['business-full-name'].value} onChange={onFieldCahngeHandeler('business-full-name')} className={'input'} error={fields['business-full-name'].error} />
              </div>
              <div className='input-with-label'>
                <PigeItInput label="Company's Name" id='business-name' value={fields['business-name'].value} onChange={onFieldCahngeHandeler('business-name')} className={'input'} error={fields['business-name'].error} />
              </div>
            </div>
            <div className='two-fields display-flex'>
              <div className='input-with-label'>
                <PigeItInput label='Email Address' id='business-email' value={fields['business-email'].value} onChange={onFieldCahngeHandeler('business-email')} className={'input'} error={fields['business-email'].error} />
              </div>
              <div className='input-with-label'>
                <PigeItInput label="Company's Address" id='business-address' value={fields['business-address'].value} onChange={onFieldCahngeHandeler('business-address')} className={'input'} error={fields['business-address'].error} />
              </div>
            </div>
            <div className='two-fields display-flex'>
              <div className='input-with-label'>
                <PigeItInput label='Nature of Business' id='business-industry' value={fields['business-industry'].value} onChange={onFieldCahngeHandeler('business-industry')} className={'input'} error={fields['business-industry'].error} />
              </div>
              <div className='input-with-label'>
                <PigeItInput label='Website URL' id='business-link' value={fields['business-link'].value} onChange={onFieldCahngeHandeler('business-link')} className={'input'} error={fields['business-link'].error} />
              </div>
            </div>
            <div className='textarea-with-label'>
              <PigeItInput label='Tell us about your experience with ShipWinner!' multiline id='business-about' value={fields['business-about'].value} onChange={onFieldCahngeHandeler('business-about')} className={'textarea first'} error={fields['business-about'].error} />
            </div>
            <div className='textarea-with-label'>
              <PigeItInput label="I'd like to make an offer to ShipWinner users:" multiline id='business-offer' value={fields['business-offer'].value} onChange={onFieldCahngeHandeler('business-offer')} className={'textarea'} error={fields['business-offer'].error} />
            </div>
            <PigeitCaptcha  className="recaptcha" onVerify={(token) => setCaptcha(token)} />
          </form>}
        <button className='become-partner-button' onClick={onBecomePartnerClick}>WRITE A REVIEW!</button>
      </MainPageBusinessReviewsStyle>
    );
  } else {
    return null;
  }
  function onLeftClick() {
    if (!isNaN(sectionRef.current)) {
      lastPressedRef.current = Date.now();
      setSection((sectionRef.current - 1) < 0 ? sections - 1 : sectionRef.current - 1);
    }
  }

  function onRightClick() {
    if (!isNaN(sectionRef.current)) {
      lastPressedRef.current = Date.now();
      setSection((sectionRef.current + 1) % sectionsRef.current);
    }
  }

  function setToCloseOnClickOutside(evt) {
    if (!isDescendant(openReviewRef.current, evt.target) && reviewToOpenRef.current !== -1) {
      setReviewToOpen(-1);
    }
  }

  function onBecomePartnerClick(e) {
    if (!formOpen) {
      setFormOpen(true);
      return;
    }
    let newFields = {};
    let errorflag = false;
    Object.entries(fields).forEach(ent => {
      if (ent[1].value === '') {
        newFields[ent[0]] = { value: '', error: true };
        errorflag = true;
      } else {
        newFields[ent[0]] = { value: ent[1].value, error: false }
      }
    });
    if (errorflag) {
      setFields(newFields);
      return;
    } else {
      dispatch(setupAnimatedLoader({ isVisible: true }));
      dispatch(api_businessReviews_add({
        fullName: fields['business-full-name'].value,
        link: fields['business-link'].value,
        businessName: fields['business-name'].value,
        industry: fields['business-industry'].value,
        textAboutPigeit: fields['business-about'].value,
        textAboutOffer: fields['business-offer'].value,
        email: fields['business-email'].value,
        address: fields['business-address'].value,
        captcha: captcha,
        callback: function (result) {
          dispatch(setupAnimatedLoader({ isVisible: false }));
          if (result.success) {
            setFormOpen(false);
            setFields({
              'business-full-name': { value: '', error: false },
              'business-name': { value: '', error: false },
              'business-email': { value: '', error: false },
              'business-address': { value: '', error: false },
              'business-industry': { value: '', error: false },
              'business-link': { value: '', error: false },
              'business-about': { value: '', error: false },
              'business-offer': { value: '', error: false },
            });
            let modalConfig = {
              ...CONSTANTS.MODALS_CONFIG.MESSAGE,
              buttons: { ok: { visible: true, text: 'OK' }, cancel: { visible: false, text: 'CANCEL' } },
              message: 'Review Send Successfully. We will contact you soon!',
            };
            dispatch(modalQueue({ mode: 'insert', modalConfig: modalConfig }));
          } else {
            showErrorMessage(result, dispatch);
          }
        }
      }));
    }

  }
  function onFieldCahngeHandeler(id) {
    return (e) => {
      setFields({ ...fields, [id]: { value: e.target.value, error: false } });
    }
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    displayMode: state.data.displayMode,
    businessReviews: get(state, 'data.api.businessReviews', []),
  }
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
  }
};

const MainPageBusinessReviewsStyle = styled.div`
.email-address-header{
  text-align: left;
    color: black;
    font-size: 16px;
}
  .recaptcha{
    display: flex;
    justify-content: center;
    margin-top: 30px;
  }
  .form{
    padding: 10px 160px;
    margin: 20px 15%;
    margin-top:40px;
  }
  .input{
  }
  .label{
    display: block;
    margin-top: 20px;
    margin-bottom: 5px;
  }
  .textarea{
    margin: 25px 0;
    &.error{
      border: solid 1px ${Colors.error};
    }
  }
  .input-with-label{
    flex: 0 0 49%;
  }
  .two-fields{
    justify-content: space-between;
    margin: 25px 0;
  }
  .main-header{
    text-align: center;
    font-size: 40px;
    margin: 30px 15%;
  }
  .second-header{
    text-align: center;
    font-size: 22px;
    color: #848484;
    margin: 0 10%;
  }
  .reviews-container{
    margin: 40px 10%;
    justify-content: space-between;
    .left-button, .right-button{
      &.hide{
        visibility: hidden;
      }
      background: none;
      border: none;
      outline: none;
      cursor: pointer;
      svg{
        width: 54px;
        height: 32px;
        path{
          fill: ${Colors.blue1};
        }
      }
    }
    .review-container{
      flex: 0 0 29%;
      display: block;
      background: none;
      border: none;
      outline: none;
      cursor: pointer;
    }
    .review-container{
      .floating-container{
        position: absolute;
        box-shadow: 0px 0px 5px grey;
        background: white;
        width: 22%;
        padding-bottom: 14px;
        .review-text{
          height:unset;
        }
      }
      .profile-image{
        width: 120px;
        height: 120px;
        margin: auto;
        display: block;
        border-radius: 120px;
        margin-top: 20px;
        margin-bottom: 20px;
      }
      .review-title{
        text-align: center;
        font-size: 20px;
        margin: 10px 15%;
      }
      .review-text{
        margin: 0 11%;
        text-align: center;
        text-overflow: ellipsis;
        overflow: hidden;
        min-height: 50px;
        .show-more{
          color:${Colors.blue1};
          font-family:museo_sans700;
        }
      }
      .link-to-website{
        display: block;
        font-size: 16px;
        line-height: 26px;
      }
    }
  }
  .navigtion-container{
    &.hide{
      visibility: hidden;
    }
    justify-content: center;
    .circle{
      &.selected{
        background-color:${Colors.blue1};
      }
      width: 15px;
      height: 15px;
      background: none;
      background-color: ${Colors.lightGray3};
      border-radius: 15px;
      border: none;
      outline: none;
      cursor: pointer;
      display: block;
      margin: 0 10px;
    }
  }
  .become-partner-button{
    font-size: 18px;
    border: none;
    color: #fff;
    width: 350px;
    height: 56px;
    background-color: #fcb02e;
    border-radius: 3px;
    display: block;
    margin: auto;
    margin-top: 57px;
    outline: none;
    cursor: pointer;
  }
  @media only screen and (max-width: 992px) {
    .reviews-container{
      margin: 40px 0;
      .review-container {
        .floating-container{
          width: calc(100% - 63px);
          margin-left: -40px;
        }
        flex:unset;
        width: 100%;
        .review-text{
          margin: 0 5px;
          max-height: 94px;
        }
      }
    }
    .input-with-label{
      margin: 10px 0px;
    }
    .main-header{
      font-size: 28px;
      margin: 30px 10px;
    }
    .second-header{
      font-size: 18px;
      margin: 30px 10px;
    }
    .become-partner-button{
      width: 300px;
    }
    .form{
      padding: 20px;
      margin: 0;
    }
    .textarea{
      &.first{
        margin-top: 13px;
      }
      margin: 21px 0;
    }
    .two-fields{
      margin: 0;
      flex-direction: column;
    }
  }
 `;

const MainPageBusinessReviews = connect(
  mapStateToProps,
  mapDispatchToProps
)(MainPageBusinessReviewsComponent);

export default MainPageBusinessReviews;
